import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ModalConfirmComponent } from '../../../../components/modal-confirm/modal-confirm.component';
var subCategoriesListComponent = /** @class */ (function () {
    function subCategoriesListComponent(categoriesService, snackBar, location, dialog, route) {
        this.categoriesService = categoriesService;
        this.snackBar = snackBar;
        this.location = location;
        this.dialog = dialog;
        this.route = route;
        this.headersTable = ['heading', 'order', 'status', 'actions'];
        this.subCategories = [];
    }
    subCategoriesListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.categoryId = this.route.snapshot.paramMap.get('categoryID');
        this.categoriesService.findOne(this.categoryId).then(function (response) {
            _this.category = response.heading;
        }, function (error) {
            console.log(error);
            _this.snackBar.open(error.error.message);
        });
        this.listCategories();
    };
    subCategoriesListComponent.prototype.listCategories = function () {
        var _this = this;
        this.categoriesService.listSubCategories(this.categoryId).then(function (response) {
            _this.subCategories = response;
        }, function (error) {
            console.log(error);
            _this.snackBar.open(error.error.message);
        });
    };
    subCategoriesListComponent.prototype.remove = function (id) {
        var _this = this;
        this.dialog
            .open(ModalConfirmComponent, {
            width: '500px',
            data: {
                text: 'Deseja remover essa Subcategoria?',
                buttonConfirmText: 'Remover',
            },
        })
            .afterClosed()
            .toPromise()
            .then(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (result && result !== 'cancel') {
                    return [2 /*return*/, this.categoriesService.deleteSubCategories(id).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.listCategories();
                                this.snackBar.open('Subcategoria removida com sucesso.');
                                return [2 /*return*/];
                            });
                        }); }, function (error) {
                            console.log(error);
                            _this.snackBar.open(error.error.message);
                        })];
                }
                return [2 /*return*/];
            });
        }); })
            .catch(function (err) {
            _this.snackBar.open(err.message);
        });
    };
    return subCategoriesListComponent;
}());
export { subCategoriesListComponent };
